<template>
    <div class="max-width-content">

        <breadcrumbs>
            <inertia-link :href="route('admin.blogcategories.index')">Blogrubrieken</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.blogcategories.show', blogCategory.id)">{{ blogCategory.name | truncate(35) }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <blog-category-form :blog-category="blogCategory" @submit="submit" :data-loading="loading"></blog-category-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import BlogCategoryForm from "@/admin/Pages/BlogCategory/BlogCategoryForm";

export default {
    metaInfo() {
        return { title: this.blogCategory.name };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        Breadcrumbs,
        BlogCategoryForm
    },

    mixins: [Helpers],

    props: {
        blogCategory: Object,
    },

    data() {
        return {
            form: {
                name: this.blogCategory.name,
            }
        };
    },

    methods: {
        submit(form) {
            this.loading = "submit";

            const url = this.route("admin.blogcategories.update", this.blogCategory.id)
            const options = {
                onFinish: () => this.loading = false
            };

            this.$inertia.patch(url, form, options);
        }
    }
};
</script>
